import { useMutation, useQuery } from "./urqlHooks";

const GET_PROVIDER_LABELS = `query GET_PROVIDER_LABELS($companyId: String!) {
  getProviderLabels(companyId: $companyId) {
    name
    icon
    color
    key
  }
}`;

export const GetProviderLabels = ({ companyId }) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_PROVIDER_LABELS,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_COLLECTION_LABELS = `query GET_COLLECTION_LABELS($companyId: String!) {
  getCollectionLabels(companyId: $companyId) {
    name
    icon
    color
    key
  }
}`;

export const GetCollectionLabels = ({ companyId }) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_COLLECTION_LABELS,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const UPDATE_LABELS = `
  mutation UPDATE_LABELS($companyId: String!, $labels: [LabelInput!]!) {
    updateLabels(companyId: $companyId, labels: $labels){
      status
      message
    }
  }
`;

export const UpdateLabels = () => {
  const [result, executeMutation] = useMutation(UPDATE_LABELS);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const CREATE_COLLECTION_LABEL = `
  mutation CREATE_COLLECTION_LABEL($companyId: String!, $label: LabelInput!) {
    createCollectionLabel(companyId: $companyId, label: $label){
      status
      message
    }
  }
`;

export const CreateCollectionLabel = () => {
  const [result, executeMutation] = useMutation(CREATE_COLLECTION_LABEL);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const UPDATE_COLLECTION_LABELS = `
  mutation UPDATE_COLLECTION_LABELS($companyId: String!, $labels: [LabelInput!]!) {
    updateCollectionLabels(companyId: $companyId, labels: $labels){
      status
      message
    }
  }
`;

export const UpdateCollectionLabels = () => {
  const [result, executeMutation] = useMutation(UPDATE_COLLECTION_LABELS);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};
